import { createContext } from "react";
import { StoreApi } from "zustand";

import { MultiActivityFormStoreType } from "./multi_activity_form_store.types";

type MultiActivityFormStoreContextType = StoreApi<MultiActivityFormStoreType>;

export const MultiActivityFormStoreContext = createContext<MultiActivityFormStoreContextType>(
  {} as MultiActivityFormStoreContextType
);
